import {
  GenericCTAListFields,
  GenericCTAListProps,
  GenericCTAListParams,
  CardList,
} from "../types/GenericCTAList.types";

export class GenericCTAListModel {
  private readonly fields?: GenericCTAListFields;
  private readonly params?: GenericCTAListParams;

  constructor(props: GenericCTAListProps) {
    this.fields = props.fields;
    this.params = props.params;
  }

  get list(): CardList[] {
    return this.fields?.List ?? [];
  }

  get variant(): string {
    return this.params?.Variant ?? '';
  }

  get title(): string {
    return this.fields?.Title?.value ?? '';
  }
}
